.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.container {
  display: flex;
  align-items: start;
  .objects {
    width: 350px;
  }
}

.subtitle {
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
  width: fit-content;
}

gz-checkbox {
  width: auto;
}

.helper-text {
  --form-field-label-width: 223px;
}

gz-chips-generator-input {
  --form-field-with-floating-max-width: 445px;
  --chip-list-width: 490px;
}


.width-60 {
  width: 60%;
}

gz-selection-card-group {
  max-width: 1072px;
}

gz-text {
  max-width: 886px;
}
